import React from "react";

import { Backdrop, Box, CircularProgress, Stack, Typography } from "@mui/material";

export default class ZPlayUploadLoader extends React.Component<{ progress: number, message?: string }, {}> {

    render() {
        return (<Backdrop
            sx={{
                color: "#FFFFFF",
                zIndex: (theme) => theme.zIndex.drawer + 10
            }}
            open={true}>
            <Box>
                <Stack direction="column" sx={{ display: "flex", alignContent: "center", alignItems: "center", justifyContent: "center" }}>
                    {this.props.message && <Typography color={"inherit"} variant={"h2"} sx={{ mb: "5px" }}>
                        {this.props.message}
                    </Typography>}
                    <CircularProgress color="inherit" size={"7rem"} sx={{ mt: 1, mb: 1 }} />
                    <Typography color={process.env.REACT_APP_SECONDARY_COLOR} variant={"h2"} sx={{ fontWeight: "bold" }}>
                        {this.props.progress}%
                    </Typography>
                </Stack>
            </Box>
        </Backdrop>);
    }
}
